<my-bill-odb-page-base-structure
  [billingDocument]="billingDocument"
  [hasCommonHeader]="hasDataAvailable && !isFetching"
  [customTitle]="section?.description"
  [hasCustomHeader]="true"
>
  <div class="row collapse" customHeader *ngIf="address">
    <div class="rs-auto">
      <i
        class="icon-Place-map rs-margin-right1 rs-txt-s7 rs-txt-c2 icon-lh"
        aria-hidden="true"
      ></i>
    </div>
    <div class="rs-last">
      <p class="rs-txt-s5 rs-font-pxB">{{ address }}</p>
    </div>
  </div>
  <!--///////////////   LEFT Column content   //////////////////-->
  <ng-container leftColumnContent *ngIf="hasDataAvailable && !isFetching">
    <ng-container
      *ngFor="let explanationType of explanationsIntroPages$ | async"
    >
      <my-bill-odb-explanation-intro
        [billExplanationType]="explanationType"
      ></my-bill-odb-explanation-intro>
    </ng-container>

    <div class="rs-panel-big rs-bg-c2">
      <div
        my-bill-odb-product-split-identifier
        [identifier]="selectedSectionProductSplitIdentifier"
        [category]="category"
        [divisionType]="division.type"
      ></div>
      <p>
        <strong>{{ duration }}</strong>
      </p>
      <div class="rs-entrypoint-container">
        <ng-container
          class="rs-entrypoint-container"
          *ngFor="let item of section.items; index as itemIndex"
        >
          <my-bill-odb-section-variant-two
            [label]="item.description"
            [amount]="item.amount"
            [linkZone]="'mybill.detail.item'"
            (sectionClick)="onUsageItemClick(item, itemIndex)"
          ></my-bill-odb-section-variant-two>
        </ng-container>
      </div>
    </div>
    <!-- TOTAL -->
    <div
      class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
      my-bill-odb-total
      [amount]="section.amount"
    ></div>
  </ng-container>
</my-bill-odb-page-base-structure>
<my-bill-modal-login-required
  [showModal]="showModal"
  [redirectToLoginLink]="redirectLink"
  *ngIf="showModal"
  (hideModal)="onCancel()"
>
</my-bill-modal-login-required>
